import { LockOutlined } from '@mui/icons-material';
import { Checkbox, Tooltip } from '@thedealersconcierge/components';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { kioskDealershipAtom } from '~/state/kiosk';

const SectionElementRow: FC<{
  title: string;
  subtitle?: string;
  subtitleClassName?: string;
  iconLeft: ReactNode;
  iconLeftColor: string;
  iconRight?: ReactNode;
  onClick?: () => void;
  checked: boolean;
  onCheckboxChange: () => void;
  isEncrypted?: boolean;
}> = ({
  title,
  subtitle,
  subtitleClassName,
  iconLeft,
  iconLeftColor,
  iconRight,
  checked,
  onCheckboxChange,
  onClick,
  isEncrypted
}) => {
  const { t } = useTranslation();
  const kioskMode = useAtomValue(kioskDealershipAtom);
  return (
    <div className="flex flex-row w-full md:px-14 space-x-spacing-04">
      {/* 
        REQ-KMSP-01 - We don't display the Checkbox on Kiosk Mode, it is a security risk to enable Download on Kiosk mode 
        Document downloads are only enabled on User device or Non Kiosk Mode
      */}
      {!kioskMode && (
        <div
          className="flex flex-row items-center justify-center p-spacing-01  cursor-pointer"
          onClick={onCheckboxChange}
        >
          <Checkbox
            checked={checked}
            onChange={onCheckboxChange}
            size="LARGE"
            disabled={false}
            labelClassName="items-center justify-center"
          />
        </div>
      )}

      <div
        className={classNames(
          'flex flex-row py-3 justify-between items-center w-full',
          { 'cursor-pointer': !!onClick }
        )}
        onClick={onClick}
      >
        <div className="flex flex-row space-x-6 items-center w-full">
          <div
            className="flex w-12 min-w-12 aspect-square rounded-lg items-center justify-center text-white"
            style={{ backgroundColor: iconLeftColor }}
          >
            {iconLeft}
          </div>

          <div>
            {isEncrypted ? (
              <div className="flex flex-row gap-2">
                <p>
                  {title} ({t('Encrypted')})
                </p>

                <Tooltip
                  anchor={
                    <div
                      className="flex justify-between items-center"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <LockOutlined
                        className="icon-tertiary"
                        sx={{ fontSize: 20 }}
                      />
                    </div>
                  }
                  content={
                    <p>
                      {t(
                        'This file is encrypted and cannot be printed or downloaded with other files.'
                      )}
                    </p>
                  }
                />
              </div>
            ) : (
              <p>{title}</p>
            )}

            {subtitle && (
              <p className={classNames('text-tertiary', subtitleClassName)}>
                {subtitle}
              </p>
            )}
          </div>
        </div>

        {iconRight && <div>{iconRight}</div>}
      </div>
    </div>
  );
};

export default SectionElementRow;
